export default __webpack_public_path__ + "static/media/digital-nomad-visa-portugal.df2d59cf.jpg";